import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useOrganization} from '../hooks/useOrganization.ts';
import {useOrganizationsSelection} from '../hooks/useOrganizationsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {IndexPage as OrganizationAccountsPage} from "../../organization-accounts/pages/IndexPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";


export const EditPage = () => {

    const {allowedActions} = useVerifiedPermissions()

    const {id: organizationId} = useParams();

    if (typeof organizationId === 'undefined') {
        throw new Error('organizationId is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/organizations/${organizationId}`);
    }

    const {
        record: organization,
        updateRecord,
    } = useOrganization(organizationId);

    const {handleClearSelection} = useOrganizationsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!organization) {
        return <PlatformLoader message='Loading organization...Please wait'/>;
    }

    const tabs = []
    if (allowedActions.includes(rbacActions.ListAccounts)) {
        tabs.push({
                      title: 'Accounts',
                      component: <OrganizationAccountsPage/>
                  })
    }

    return (
        <FormPageLayout
            title={organization.name ? organization.name : organization.id}
            pageNavigation={<EditPageNavigation component={organization}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={organization}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <SimplePageContentWrapper>
                            <TabbedComponent tabs={tabs}></TabbedComponent>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={organization}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
